import { render, staticRenderFns } from "./Hitmaps.vue?vue&type=template&id=54b2e0d3&"
import script from "./Hitmaps.vue?vue&type=script&lang=js&"
export * from "./Hitmaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports